import React from 'react'
import PropTypes from 'prop-types'

import { UIText, UIButton, UILayout, UIIcon } from 'bora-material-ui'
import UIElements from '../../../../consts/UIElements'

const IDButton = ({ click, translate, margin, xs, icon, buttonColor, disabled }, { muiTheme }) => (
  <UIButton
    width="100%"
    height="64px"
    click={click}
    border-radius="4px"
    disabled={disabled}
    xs={{ width: '100%', ...xs }}
    background={buttonColor || UIElements.BUTTONS_COLOR}
    margin={margin}
  >
    <UILayout column j-flex-center lineHeight="30px" height="100%" style={{ flexBasis: '0' }}>
      <UIText align="left" size="24px">
        <UILayout row center>
          <UIIcon style={{ position: 'absolute' }} fill="white" type={icon} margin="0 0 0 11px" />
          <UIText
            align="center"
            width="100%"
            size="18px"
            xs={{ size: '20px' }}
            lineHeight="1"
            letterSpacing="0.8px"
            weight="bold"
            translate={translate}
            textTransform="uppercase"
            font={muiTheme.secondFontFamilyDem}
          />
        </UILayout>
      </UIText>
    </UILayout>
  </UIButton>
)

IDButton.defaultProps = {
  margin: '0px',
  xs: {},
  icon: '',
  buttonColor: '',
  disabled: false,
}

IDButton.propTypes = {
  click: PropTypes.func.isRequired,
  translate: PropTypes.object.isRequired,
  margin: PropTypes.string,
  xs: PropTypes.object,
  icon: PropTypes.string,
  buttonColor: PropTypes.string,
  disabled: PropTypes.bool,
}

IDButton.contextTypes = {
  muiTheme: PropTypes.object,
}

export default IDButton
